import { ResourceUsage, Subscription } from "@/types/subscription"
import { useQuery } from "@tanstack/react-query"
import { useCosineMutation } from "./mutation"
import { cosinePost } from "./default-query"
import { SubscriptionPlan } from "@/types/subscription"

export const SubscriptionKey = "subscription"

export const useSubscription = (teamId: string) => {
  return useQuery<Subscription>({
    queryKey: [SubscriptionKey, `/subscription/${teamId}`],
  })
}

export const usePurchaseSubscriptionUrl = ({
  teamId,
  teamSlug,
  successUrl,
}: {
  teamId: string
  teamSlug: string
  successUrl?: string
}) => {
  return useCosineMutation<{ url: string }, SubscriptionPlan>({
    mutationFn: (plan) =>
      cosinePost<{ url: string }>("/subscription/purchase", { teamId, teamSlug, plan, successUrl }),
    event: "purchase_subscription",
  })
}

export const usePurchaseTasksUrl = ({
  teamId,
  teamSlug,
  successUrl,
}: {
  teamId: string
  teamSlug: string
  successUrl?: string
}) => {
  return useCosineMutation<{ url: string }>({
    mutationFn: () =>
      cosinePost<{ url: string }>("/subscription/purchase/tasks", { teamId, teamSlug, successUrl }),
    event: "purchase_tasks",
  })
}

export const useManageSubscriptionUrl = ({
  teamSlug,
  stripeCustomerId,
  successUrl,
}: {
  teamSlug: string
  stripeCustomerId: string
  successUrl?: string
}) => {
  return useCosineMutation<{ url: string }>({
    mutationFn: () =>
      cosinePost<{ url: string }>("/subscription/manage", {
        teamSlug,
        stripeCustomerId,
        successUrl,
      }),
    event: "manage_subscription",
  })
}

export const useResourceUsage = (teamId: string) => {
  return useQuery<ResourceUsage[]>({
    queryKey: [SubscriptionKey, `/subscription/${teamId}/usage`],
  })
}
